import { ThemeProvider } from "@mui/material";
import { SnackbarProvider } from 'notistack';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from "react-router-dom";
import MainTheme from "./assets/theme";
import { router } from "./routes/AllRoutes";
import "./utils/polyfills";


const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
    <React.StrictMode>
        <ThemeProvider theme={MainTheme}>
            <SnackbarProvider maxSnack={3} anchorOrigin={{vertical: "bottom", horizontal: "right"}}>
                <RouterProvider router={router}/>
            </SnackbarProvider>
        </ThemeProvider>
    </React.StrictMode>
);
